import { Capacitor } from '@capacitor/core';
import { env } from '@config/env';

/** Single source of truth for runtime-platform decisions. */
export const platform = {
  isNative: (): boolean => Capacitor.isNativePlatform(),
  isIOS: (): boolean => Capacitor.getPlatform() === 'ios',
  isAndroid: (): boolean => Capacitor.getPlatform() === 'android',
  isWeb: (): boolean => Capacitor.getPlatform() === 'web',
  /** Used when authoring user-agent strings or analytics dimensions. */
  name: (): 'ios' | 'android' | 'web' => Capacitor.getPlatform() as 'ios' | 'android' | 'web',
};

/** True if running under `capacitor://` origin — distinguishes native shell from web PWA. */
export function isCapacitorOrigin(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.protocol === 'capacitor:';
}

/**
 * Base URL for building shareable/public links (e.g. access-invite URLs). Native runs
 * under `capacitor://`, which isn't web-addressable — use the configured https
 * `portalBaseUrl` (the PWA's public URL) there; the web PWA uses its real origin.
 */
export function publicBaseUrl(): string {
  const base = isCapacitorOrigin() ? env.portalBaseUrl : window.location.origin;
  return base.replace(/\/$/, '');
}
